
























































import {Vue, Component} from 'vue-property-decorator'
import {EventBus} from '../main'
import {AppConfig, LoginRequest} from '../lib/kepler/interfaces'
import {Action, State} from 'vuex-class'
import {DialogState, PopupState} from '../store'

import CloseButton from '../components/CloseButton.vue'
import QuickRegistrationView from '../views/QuickRegistration.vue'
import ResetPasswordView from '../views/ResetPassword.vue'
import Container from '../components/proxy/Container.vue'
import TextField from '../components/proxy/Inputs/TextField.vue'
import Button from '../components/Button.vue'
import FormTag from '../components/proxy/Inputs/FormTag.vue'
import Layout from '../components/proxy/Layout.vue'
import Img from '../components/proxy/Image.vue'
import LoginByPhone from './LoginByPhone.vue'
import {AppConfigState} from '@/store/modules/configuration'
import LoopingBG from '@/components/LoopingBG.vue'

@Component({
  components: {
    LoopingBG,
    Img,
    Layout,
    FormTag,
    Button,
    TextField,
    Container,
    CloseButton,
  },
  name: 'LoginView',
})
export default class Login extends Vue {
  @State('configuration') public configuration!: AppConfigState
  @Action('loadConfig') public loadConfig: any

  @Action('openDialog') public openDialog: any
  @Action('openPopup') public openPopup: any

  @Action('closePopup') public closePopup: any

  @Action('login') public login: any

  protected showPassword: boolean = false
  protected credentials: LoginRequest = {username: '', password: ''}
  protected loading: boolean = false
  protected valid: boolean = false

  protected usernameRules: any = [
    (v: any) => !!v || 'Name is required',
  ]

  protected passwordRules: any = [
    (v: any) => !!v || 'Password is required',
  ]

  protected get smsLoginEnabled() {
    if (!this.configuration.appConfig) {
      return true
    }
    const l = this.configuration.appConfig.sms_login_enabled
    if (!this.configuration.appConfig || typeof l !== 'boolean') {
      this.loadConfig.then(() => {
        return this.configuration.appConfig.sms_login_enabled
      })
    } else {
      return l
    }
  }

  protected loginRequest() {
    if ((this.$refs as any).loginForm.validate()) {
      this.loading = true
      this.login(this.credentials).then(() => {
        this.closePopup()
        if (this.$route.name !== 'home') {
          this.$router.push({name: 'home'})
        }
      }).finally(() => {
        this.loading = false
      })
    }
  }

  protected openRegistration() {
    this.closePopup()
    this.$router.push({name: 'registration'})
  }

  protected openResetPasswordView() {
    this.openPopup(new PopupState(ResetPasswordView, null), null, this.$t('login.reset_your_password'), false)
  }

  protected loginByPhone() {
    this.openPopup(new PopupState(LoginByPhone, null), null, this.$t('login.login_by_phone'), false)
  }
}
